<section [formGroup]="form" class="form-group" [attr.aria-label]="'base.field.group.address' | transloco">
	<div class="search-field-group">
		<lvr-field
			[label]="
				showAsterisk()
					? ('base.field.street_address' | transloco | appendAsterisk)
					: ('base.field.street_address' | transloco)
			"
			class="address-fields"
		>
			<mat-form-field lvrInput [class.lvr-warning]="showDuplicatedWarning()" [lvrError]="hasRequiredError">
				<input matInput formControlName="streetAndHouseNumber" placeholder="Hauptstraße 12" [matAutocomplete]="auto" />
				<mat-autocomplete
					#auto="matAutocomplete"
					autoActiveFirstOption
					[displayWith]="displayAddress"
					(optionSelected)="addressSelected($event)"
				>
					@for (option of suggestions(); track option) {
						<mat-option [value]="option">
							{{ option.streetAndHouseNumber }} - {{ option.postalCodeAndCity }}
						</mat-option>
					}
					@if (suggestions().length === 0) {
						<mat-option disabled>
							{{ 'base.form.warning.no_address_suggestion' | transloco }}
						</mat-option>
					}
				</mat-autocomplete>
			</mat-form-field>
		</lvr-field>
		<lvr-field
			[label]="
				showAsterisk()
					? ('base.field.postal_code_and_city' | transloco | appendAsterisk)
					: ('base.field.postal_code_and_city' | transloco)
			"
			class="address-fields"
		>
			<mat-form-field
				lvrInput
				[class.lvr-warning]="showWarning() || showDuplicatedWarning()"
				[lvrError]="invalidFormat() || hasRequiredError"
			>
				<input matInput formControlName="postalCodeAndCity" placeholder="12345 Stadt" [matAutocomplete]="auto" />
				<mat-autocomplete
					#auto="matAutocomplete"
					autoActiveFirstOption
					[displayWith]="displayAddress"
					(optionSelected)="addressSelected($event)"
				>
					@for (option of suggestions(); track option) {
						<mat-option [value]="option">
							{{ option.streetAndHouseNumber }} - {{ option.postalCodeAndCity }}
						</mat-option>
					}
					@if (suggestions().length === 0) {
						<mat-option disabled>
							{{ 'base.form.warning.no_address_suggestion' | transloco }}
						</mat-option>
					}
				</mat-autocomplete>
				@if (invalidFormat()) {
					<mat-error>
						{{ 'base.form.error.postal_code_city_format' | transloco }}
					</mat-error>
				} @else if (showWarning()) {
					<mat-hint class="lvr-warning">{{ 'base.form.warning.no_german_postal_code' | transloco }}</mat-hint>
				} @else if (showDuplicatedWarning()) {
					<mat-hint class="lvr-warning">
						{{ duplicatedAddressHintKey() | transloco }}
						<a [href]="duplicatedAddressLink() + duplicateMatch()?.id">{{ duplicateMatch()?.name }}</a>
					</mat-hint>
				} @else if (hasRequiredError) {
					<mat-error>
						{{ 'base.form.error.address_required' | transloco }}
					</mat-error>
				}
			</mat-form-field>
		</lvr-field>
	</div>
</section>
